/* eslint-disable import/no-unused-modules */
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { useAuth0 } from "@auth0/auth0-react";
import { Ellipsis } from "lucide-react";
import { useState } from "react";
import { MemberTable } from "../types";
import { EditRole } from "./EditRole";
import { RemoveMemberModal } from "./RemoveMemberModal";

type Props = {
  member: MemberTable;
};

export function MemberAction({ member }: Props) {
  const [editRoleOpen, setEditRoleOpen] = useState(false);
  const [removeMemberOpen, setRemoveMemberOpen] = useState(false);

  const { user } = useAuth0();
  const isLoggedInUser = member.email === user?.email;
  if (isLoggedInUser) return null;

  return (
    <div className="flex justify-end pr-2" data-testid="memberAction">
      {removeMemberOpen && (
        <RemoveMemberModal
          closeModal={() => setRemoveMemberOpen(false)}
          memberId={member.userId}
          memberName={member.name}
        />
      )}
      <EditRole setOpen={setEditRoleOpen} member={member} open={editRoleOpen} />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <Ellipsis className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setEditRoleOpen(true)}>
            Edit role
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => setRemoveMemberOpen(true)}
            destructive
          >
            Remove member
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
